import React from 'react'
import BaseIcon from 'react-icon-base'

const LeftArrow = props => (
  <BaseIcon width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7.18 13.86.5 7.18 7.18.5l1.18 1.18L3.7 6.36h10.16V8H3.7l4.66 4.68z" fill="#85A4B0" fillRule="nonzero" />
  </BaseIcon>
)

export default LeftArrow
